import React, { Component } from 'react';
import ReactTable from "react-table";
import "react-table/react-table.css";
import { withRouter } from 'react-router-dom'
import couterpart from 'counterpart';
// import ReactTablePagination from './PaginationComponent';
import { ToastsContainer, ToastsStore } from 'react-toasts';

import { MdDeleteForever, MdModeEdit } from 'react-icons/md';
import MasterDataService from '../services/MasterDataService';

import WorkOrderDataService from '../services/WorkOrderDataService';
import AuthenticationService from '../services/AuthenticationService';
import WorkOrderUtil from '../utilities/WorkOrderUtil';

import { ICON_COLOR } from '../icon';

import { SELECTED_QR_IDX, SELECTED_WORKORDER_IDX, SERVER_URL } from '../constants';
import UserDataService from '../services/UserDataService';

class QualityReportListView extends Component {
  constructor() {
    super();

    this.state = {
      orderId: null,
      selectedRow: 0,
      selected: 0,
      childRefreshCount: 0,
      columns: [
        {
          id: "idx",
          accessor: "",
          width: 40,
          Cell: row => (
            <div style={{ padding: "10px" }}>{row.index + 1}</div>
          )
        },
        {
          id: "checkbox",
          accessor: "",
          Cell: ({ original }) => {
            return (
              <div style={{ textAlign: "center" }}>
                <input
                  type="checkbox"
                  className="checkbox"
                  checked={this.state.selected[original.id] === true}
                  onChange={() => this.toggleRow(original.id)}
                /></div>
            );
          },
          Header: x => {
            return (
              <input
                type="checkbox"
                className="checkbox"
                checked={this.state.selectAll === 1}
                ref={input => {
                  if (input) {
                    input.indeterminate = this.state.selectAll === 2;
                  }
                }}
                onChange={() => this.toggleSelectAll()}
              />
            );
          },
          sortable: false,
          width: 45
        },
        {
          Header: couterpart.translate('quality_sodh'),
          accessor: 'soDh',
          width: 150,
          Cell: row => (
            this.linkToDetails(row)
          )
        }, {
          Header: couterpart.translate('quality_masx'),
          width: 150,
          accessor: 'maSx',
          filterable: false
        }, {
          Header: couterpart.translate('quality_ngayshipvn'),
          width: 150,
          accessor: 'ngayShipVn',
          filterable: false
        }, {
          Header: couterpart.translate('quality_ngaykhnhan'),
          width: 150,
          accessor: 'ngayKhNhanHang',
          filterable: false
        }, {
          Header: couterpart.translate('quality_ngaysuco'),
          width: 150,
          accessor: 'ngaySuCo',
          filterable: false
        }, {
          Header: couterpart.translate('quality_ngayreport'),
          width: 150,
          accessor: 'createdAt',
          filterable: false
        }, {
          Header: couterpart.translate('quality_loaisuco'),
          width: 150,
          accessor: 'loaiSuCo',
          filterable: false,
          Cell: props => this.getLoaiSuCoDescription(props.value)
        }, {
          Header: couterpart.translate('quality_motasuco'),
          width: 150,
          accessor: 'moTaSuCo',
          filterable: false
        }, {
          Header: couterpart.translate('quality_copyhasuco'),
          width: 250,
          accessor: 'hinhAnhSuCo',
          Cell: row => (
            <div style={{ textAlign: "center" }}> { this.linkToImage(row) } </div>
          )
        }, {
          Header: couterpart.translate('quality_tho'),
          width: 250,
          accessor: 'tho',
          Cell: props => this.getWorkerById(props.value)
        }, {
          Header: couterpart.translate('quality_nguyennhan'),
          width: 150,
          accessor: 'nguyenNhan',
          filterable: false
        }, {
          Header: couterpart.translate('quality_giaiphap'),
          width: 150,
          accessor: 'giaiPhap',
          filterable: false
        }, {
          Header: couterpart.translate('quality_tinhtrangsuco'),
          width: 150,
          accessor: 'tinhTrang',
          filterable: false,
          Cell: props => this.getTinhTrangDescription(props.value)
        }, {
          Header: couterpart.translate('quality_action'),
          accessor: 'action',
          width: 150,
          Cell: row => (
            <div style={{ textAlign: "center" }}>
              {this.renderEditButton(row)}
            </div>
          )
        }]
    };
  }

  loadWorkers() {
    if (AuthenticationService.isAdmin() || AuthenticationService.isService() || AuthenticationService.isKhac() || AuthenticationService.isSupervisor()  || AuthenticationService.isQuality()) {
      UserDataService.retrieveWorkers().then(data => {
        this.setState({ workers: data });
      });
    }
  }

  getWorkerById(workerId){
    if (workerId === undefined) {
      return "";
    }
    
    if (this.state.workers === undefined || this.state.workers === null){
      return "";
    }
    let worker = this.state.workers.filter(x => {
      let iworkerId = parseInt(workerId);
      return x.id === iworkerId;
    });

    if (worker === undefined || worker === null || worker.length <= 0){
      return workerId;
    }
    return worker[0].userName;
  }

  utcToLocal(utcDate){
    return new Date(utcDate).toDateString();
  }

  getTinhTrangDescription(tinhTrang){
    if (this.props.tinhTrangSuCos === undefined || this.props.tinhTrangSuCos === null){
        return tinhTrang;
    }    
    let tt = this.props.tinhTrangSuCos.find(x =>{
      return x.id === tinhTrang;
    });

    if (tt !== undefined){
      return tt.details;
    }   
    return tinhTrang;     
  }

  getLoaiSuCoDescription(loaiSuCo){
    if (this.props.loaiSuCos === undefined || this.props.loaiSuCos === null){
        return loaiSuCo;
    }    
    let tt = this.props.loaiSuCos.find(x =>{
      return x.id === loaiSuCo;
    });

    if (tt !== undefined){
      return tt.details;
    }   
    return loaiSuCo;     
  }

  toggleRow(id) {
    const newSelected = Object.assign({}, this.state.selected);
    newSelected[id] = !this.state.selected[id];
    this.setState({
      selected: newSelected,
      selectAll: 2
    }, () => {
      sessionStorage.setItem(`${SELECTED_QR_IDX}`, this.state.selected);
      this.props.parentCallback(this.state.selected);
    });
  }

  toggleSelectAll() {
    let newSelected = {};

    if (this.state.selectAll === 0) {
      this.props.qualityReports.forEach(x => {
        newSelected[x.id] = true;
      });
    }

    this.setState({
      selected: newSelected,
      selectAll: this.state.selectAll === 0 ? 1 : 0
    }, () => {
      sessionStorage.setItem(`${SELECTED_QR_IDX}`, this.state.selected);
      this.props.parentCallback(this.state.selected);
    });
  }

  renderEditButton(row) {
    const button_delete = couterpart.translate('button_delete');
    if (AuthenticationService.isAdmin() || AuthenticationService.isService()) {
      return (<div>
        <button className="myButton" onClick={() => this.handleDelete(row)}>
          <MdDeleteForever color={ICON_COLOR} />
          &nbsp;{button_delete}</button>
      </div>
      );
    } else {
      return (<></>);
    }
  }

  static getDerivedStateFromProps(nextProps, state) {
    if (nextProps.refreshCount !== state.childRefreshCount) {
      return { childRefreshCount: nextProps.refreshCount, selected: [], selectedPage: 0 }
    }
    return null;
  }

  componentDidMount() {
    this.loadWorkers();
    let tmp = WorkOrderUtil.getItem('qualityReport.selectedPage');
    let iSelectPage = 0;
    if (tmp !== undefined) {
      iSelectPage = parseInt(tmp);
    }

    this.setState({ selected: [] }, () => {
      let selected = WorkOrderUtil.getItem('qualityReport.selectedRow') ? parseInt(WorkOrderUtil.getItem('qualityReport.selectedRow')) : 0;
      this.setState({ selectedRow: selected, selectedPage: iSelectPage })
    });

    const sortedId = WorkOrderUtil.getItem('qualityReport.sortedId');
    const sortedDesc = WorkOrderUtil.getItem('qualityReport.sortedDesc');

    this.setState({
      sortedId: sortedId,
      sortedDesc: sortedDesc
    })
  }

  handleEdit(row) {
    this.props.parentEditCallback(row.original);
  }

  handleDelete(row) {
    this.props.parentDeleteCallback(row.original.id);
  }

  linkToDetails(row) {
    return (
      <label className="label_link" href="#!" onClick={() => { this.handleEdit(row) }}>{row.original.soDh}</label>
    )
  }

  getImages(fileNames){
    let arr = fileNames.split(",");
    return arr;
  }

  getFileName(fileName, soDh){
    if (soDh === undefined){
      return "";
    }
    let s = SERVER_URL + "/" + soDh.replace("/", "_") + this.changeExt(fileName);
    return s;
  }

  linkToImage(row) {
    let images = this.getImages(row.original.hinhAnhSuCo);
    return(
      <>{ images !== undefined && images.map(image => this.renderImage(image, this.getFileName(image, row.original.soDh))) }</>
    );
  }
  renderImage(image, fileName){
    return (<><a href={ fileName } target="_blank">{image}</a><br/></>);
  }

  changeExt(name){
    if (name === undefined){
      return "";
    }
    let idx = name.lastIndexOf(".");
    return name.substring(0, idx) + ".jpg";
  }

  render() {
    let sortedData = this.props.qualityReports;
    return (
      <div>
        <hr />
        <ToastsContainer store={ToastsStore} position="bottom_center" />
        <ReactTable
          NoDataComponent={() => null}
          previousText={"<"}
          nextText={">"}
          page={this.props.page}
          pages={this.props.pages}
          onPageChange={pageIndex => {
            this.setState({ selectedPage: pageIndex }, () => {
              this.props.parentCallback(this.state.selectedPage)
            })
          }}
          data={sortedData}
          columns={this.state.columns}
          defaultPageSize={10}
          showPageSizeOptions={true}
          pageSizeOptions={[3, 5, 10, 20]}
          getTrProps={(state, rowInfo, column) => {
            if (rowInfo && rowInfo.row) {
              return {
                onClick: (e) => {
                  this.setState({
                    selectedRow: rowInfo.index,
                    workOrderId: rowInfo.original.id
                  }, () => {
                    WorkOrderUtil.saveItem('qualityReport.selectedRow', this.state.selectedRow);
                  })
                },
                style: {
                  background: rowInfo.index === this.state.selectedRow ? '#DCDCDC' : 'white',
                  color: rowInfo.index === this.state.selectedRow ? 'white' : 'black'
                }
              }
            } else {
              return {}
            }
          }
          }
          onSortedChange={(c, s) => {
            // console.log(c) 
            WorkOrderUtil.saveItem('qualityReport.sortedId', c[0].id);
            WorkOrderUtil.saveItem('qualityReport.sortedDesc', c[0].desc);
          }}
        />
      </div>
    )
  }
}

export default withRouter(QualityReportListView);